import { memo, useMemo, useState } from "react";
import Name from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Name/Name";
import Actions from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Actions/Actions";
import Highlight from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Highlight/Highlight";
import Demo from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Demo/Demo";
import MenuSheet from "@coworker/apprestructured/src/task-management/components/MenuSheet/MenuSheet";
import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import MenuSheetItem from "@coworker/apprestructured/src/task-management/components/MenuSheet/MenuSheetItem/MenuSheetItem";
import { FixaInputField } from "@coworker/apprestructured/src/shared/wrappers/FixaInputField/FixaInputField";

function SwitchDemo() {
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState("Action");
  const [nbrOfItems, setNbrOfItems] = useState("5");

  const menuSheetItems = useMemo(() => {
    return Array.from({ length: parseInt(nbrOfItems) }).map((_, i) => {
      const titleWithIndex = `${title} ${i + 1}`;
      return (
        <MenuSheetItem
          key={i}
          title={titleWithIndex}
          onClick={() => alert(`Clicked ${titleWithIndex}`)}
        />
      );
    });
  }, [nbrOfItems, title]);

  return (
    <Demo>
      <Name>MenuSheet</Name>
      <Highlight>
        <>
          <FixaButton type="tertiary" onClick={() => setOpen(true)}>
            Open
          </FixaButton>
          <MenuSheet visible={open} onCloseClick={() => setOpen(false)}>
            {menuSheetItems}
          </MenuSheet>
        </>
      </Highlight>
      <Actions>
        <FixaInputField
          label="title"
          type="text"
          id="menusheetdemo-title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
        <FixaInputField
          id="menusheetdemo-nbrOfItems"
          value={nbrOfItems}
          onChange={(e) => setNbrOfItems(e.target.value)}
          type="number"
          min="0"
          max="100"
          label="nbrOfItems"
        />
      </Actions>
    </Demo>
  );
}

export default memo(SwitchDemo);
